import { TFunction } from 'i18next';
import { validPhoneRegex } from 'shared/validators/phone.validator';
import * as yup from 'yup';

export const authSignUpValidator = (t: TFunction) =>
  yup.object({
    firstName: yup.string().required(t('signUp.validationError.firstNameRequired')),
    lastName: yup.string().required(t('signUp.validationError.lastNameRequired')),
    middleName: yup.string().optional(),
    phone: yup
      .string()
      .required(t('signUp.validationError.phoneRequired'))
      .matches(validPhoneRegex, t('signUp.validationError.phoneInvalid')),
    sportType: yup
      .object({
        label: yup.string().required(),
        value: yup.string().required(t('signUp.validationError.sportTypeRequired')),
      })
      .required(t('signUp.validationError.sportTypeRequired')) as yup.AnyObjectSchema,
    tournamentName: yup.string().required(t('signUp.validationError.tournamentNameRequired')),
  });
